var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "arrow-icon", style: _vm.iconDirection }, [
    _c(
      "svg",
      {
        staticStyle: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "stroke-linecap": "square",
          "stroke-miterlimit": "1.5"
        },
        attrs: {
          width: _vm.iconSize,
          viewBox: "0 0 36 54",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "xml:space": "preserve"
        }
      },
      [
        _c("path", {
          style: "fill:none;stroke:" + _vm.color + ";stroke-width:10px;",
          attrs: { d: "M9.014,9.014l17.524,17.524l-17.524,17.525" }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }